<div class="leasing-tab">
  <div class="leasing-tab__form">
    <dv-dynamic-form
      [elements]="tab.financingElements | translateElements"
      formTitle="{{ 'VehicleLeasingTab.Financing' | translate | uppercase }}"
      [formGroup]="formGroup">
    </dv-dynamic-form>
    <hr class="form-divider" />
    <dv-dynamic-form
      class="dynamic-form-background"
      [elements]="tab.statusElements | translateElements"
      formTitle="{{
        'VehicleLeasingTab.CurrentStatus' | translate | uppercase
      }}"
      [formGroup]="formGroup">
    </dv-dynamic-form>
    <hr class="form-divider" />
  </div>
  <div class="leasing-tab__chart" echarts [options]="chartOption"></div>
</div>
<dv-save-panel
  (save)="onSave()"
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}">
</dv-save-panel>
